import { lazy } from 'app/lazy'
import AuthenticatedRoute from 'app/ui/AuthenticatedRoute'
import { Main } from 'features/common/ui/AppTemplate'
import { LazyLoad } from 'features/common/ui/LazyLoad'
import { Outlet } from 'react-router-dom'
import { FiltersProvider } from '../context/filters/provider'
import { SubscriptionsProvider } from '../context/subscriptions/provider'
import { DATASET_PAGE, SEARCH_PAGE, SECTION_NAME } from '../types'
import { DataCatalogRouteNotifier } from './commons/DataCatalogRouteNotifier'

const DataCatalogHomePage = lazy(() => import('./DataCatalogHome/DataCatalogHomePage'))
const DataCatalogBrowserPage = lazy(() => import('./DataCatalogBrowser/DataCatalogBrowserPage'))
const DataCatalogProductFilePage = lazy(() => import('./DataCatalogProductFile/DataCatalogProductFilePage'))

export const DataCatalogPrivateRoutes = [
  {
    path: SECTION_NAME,
    element: (
      <AuthenticatedRoute
        element={
          <SubscriptionsProvider>
            <FiltersProvider>
              <LazyLoad>
                <Outlet />
              </LazyLoad>
            </FiltersProvider>
          </SubscriptionsProvider>
        }
      />
    ),
    children: [
      {
        index: true,
        element: <DataCatalogHomePage />
      },
      {
        path: SEARCH_PAGE,
        element: <DataCatalogBrowserPage />
      },
      {
        path: `${DATASET_PAGE}/:id`,
        element: <DataCatalogProductFilePage />
      }
    ]
  }
]

export const DataCatalogPublicRoutes = [
  {
    path: `public/${SECTION_NAME}`,
    element: (
      <SubscriptionsProvider publicView={true}>
        <FiltersProvider>
          <LazyLoad>
            <DataCatalogRouteNotifier>
              <Main>
                <Outlet />
              </Main>
            </DataCatalogRouteNotifier>
          </LazyLoad>
        </FiltersProvider>
      </SubscriptionsProvider>
    ),
    children: [
      {
        index: true,
        element: <DataCatalogHomePage />
      },
      {
        path: SEARCH_PAGE,
        element: <DataCatalogBrowserPage />
      },
      {
        path: `${DATASET_PAGE}/:id`,
        element: <DataCatalogProductFilePage />
      }
    ]
  }
]
